import { useQuery } from '@tanstack/react-query';
import { fetchAllCoupons } from '@/features/campaigns/api/couponApi';
import { queryKeys } from '@/shared/lib/query/queryKeys';

export function useCouponsQuery(params: { page: number; limit: number }) {
  return useQuery({
    queryKey: queryKeys.coupons.list(params),
    queryFn: () => fetchAllCoupons(params),
    refetchOnWindowFocus: false,
  });
}
